import { Callout, Link } from '@/components/Elements';
import { BILLING_PORTAL_URL } from '@/config';
import { SettingsLayout } from '@/features/settings/components/Layout';
import { useUser, useUserPermission } from '@/lib/auth';
import { useTranslation } from 'react-i18next';
import { createSearchParams } from 'react-router-dom';
import { ProfileSection } from '../components/ProfileSection';
import { LanguageSwitcher } from '@/components/LanguageSwitcher/LanguageSwitcher';

export const UserProfilePage = () => {
  const { t } = useTranslation();
  const { data: user } = useUser();
  const {
    licenseLabels: currentPlans,
    isOnlyBasicLicense,
    isSystemAdmin,
  } = useUserPermission();
  const subscriptionSearch = createSearchParams({
    display_basic: 'false',
  }).toString();

  return (
    <SettingsLayout>
      <ProfileSection title={t('言語設定')}>
        <LanguageSwitcher variant="settings" />
      </ProfileSection>

      <ProfileSection title={t('会員情報')}>
        {isSystemAdmin && (
          <Callout variant="warning" size="compact" className="mb-2">
            {t('システム管理者としてログインしています')}
          </Callout>
        )}
        <div>{user?.email}</div>
      </ProfileSection>

      <ProfileSection title={t('契約状況')}>
        <div className="text-sm text-gray-700">
          {t('契約中のプラン')}:{' '}
          {currentPlans.length > 0 ? currentPlans.join(' / ') : '-'}
        </div>
        {user?.hasPaymentCustomer && (
          <Link className="text-sm" to={BILLING_PORTAL_URL} target="_blank">
            {t('請求情報の管理')}
          </Link>
        )}
      </ProfileSection>

      {isOnlyBasicLicense && (
        <Link
          to={{ pathname: '/subscription', search: `?${subscriptionSearch}` }}
          target="_self"
        >
          {t('Plusプランにアップグレード')}
        </Link>
      )}
    </SettingsLayout>
  );
};
